var _path, _g, _g2, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhyUsBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1680,
    height: 450,
    viewBox: "0 0 1680 450",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.9718 209.988C110.535 174.603 155.455 170.56 218.396 172.813",
    stroke: "white",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5221_44556)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292.124 364.724C292.658 365.018 292.989 365.626 292.946 366.279C292.856 367.165 292.075 367.808 291.188 367.717L174.024 356.222C173.138 356.132 172.495 355.35 172.585 354.464C172.676 353.577 173.457 352.934 174.344 353.025L291.493 364.535C291.726 364.554 291.932 364.632 292.124 364.724Z",
    fill: "#182935"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.247 373.335C278.737 373.617 279.064 374.138 279.063 374.745C279.059 375.628 278.325 376.341 277.442 376.337L151.009 375.226C150.127 375.223 149.413 374.488 149.417 373.605C149.421 372.723 150.156 372.01 151.038 372.013L277.471 373.124C277.746 373.126 278.01 373.201 278.247 373.335Z",
    fill: "#182935"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.36 392.873C270.746 393.087 271.022 393.45 271.13 393.909C271.328 394.782 270.773 395.632 269.929 395.829L184.737 415.214C183.864 415.412 183.014 414.857 182.817 414.013C182.619 413.139 183.174 412.289 184.018 412.092L269.21 392.707C269.625 392.616 270.033 392.685 270.36 392.873Z",
    fill: "#182935"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.806 357.29C291.504 357.678 291.803 358.532 291.504 359.284C291.165 360.109 290.243 360.512 289.417 360.173L258.863 347.949C258.037 347.61 257.634 346.688 257.973 345.862C258.312 345.037 259.235 344.634 260.06 344.973L290.614 357.197C290.614 357.197 290.747 357.263 290.806 357.29Z",
    fill: "#182935"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5221_44556)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 104.646,
    height: 115.049,
    transform: "translate(1477.35) rotate(45)",
    fill: "#121D25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1402.73 81.526C1402.21 81.208 1401.91 80.5866 1401.98 79.9362C1402.11 79.0546 1402.92 78.4476 1403.8 78.5777L1520.33 95.3279C1521.21 95.458 1521.82 96.2673 1521.69 97.1489C1521.56 98.0305 1520.75 98.6375 1519.87 98.5074L1403.36 81.7428C1403.12 81.7139 1402.92 81.6271 1402.73 81.526Z",
    fill: "#182935"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1416.98 73.5482C1416.51 73.2447 1416.2 72.7099 1416.23 72.103C1416.28 71.2214 1417.04 70.5421 1417.92 70.5855L1544.18 77.378C1545.06 77.4214 1545.74 78.1874 1545.7 79.069C1545.65 79.9505 1544.89 80.6298 1544.01 80.5864L1417.75 73.7939C1417.48 73.7794 1417.22 73.6927 1416.98 73.5482Z",
    fill: "#182935"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1425.74 54.3836C1425.37 54.1523 1425.11 53.7766 1425.02 53.3141C1424.86 52.4325 1425.45 51.6087 1426.31 51.4498L1512.28 35.9136C1513.16 35.7546 1513.99 36.3471 1514.15 37.1998C1514.31 38.0814 1513.71 38.9052 1512.86 39.0642L1426.88 54.6004C1426.47 54.6726 1426.06 54.5859 1425.74 54.3836Z",
    fill: "#182935"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1403.72 89.0125C1403.04 88.5933 1402.78 87.7262 1403.11 86.9891C1403.49 86.1798 1404.43 85.8185 1405.24 86.1943L1435.21 99.7794C1436.02 100.155 1436.38 101.095 1436 101.904C1435.63 102.713 1434.69 103.075 1433.88 102.699L1403.91 89.1136C1403.91 89.1136 1403.78 89.0414 1403.72 89.0125Z",
    fill: "#182935"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M268.911 125.4C272.17 126.002 275.299 123.848 275.9 120.589C276.502 117.33 274.348 114.201 271.089 113.6L268.911 125.4ZM-7.14359 147.021C95.9204 103.008 168.214 106.817 268.911 125.4L271.089 113.6C169.143 94.7862 94.2027 90.6932 -11.8564 135.986L-7.14359 147.021Z",
    fill: "#6AD67D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1417.09 315.104C1413.83 314.502 1410.7 316.656 1410.1 319.915C1409.5 323.174 1411.65 326.303 1414.91 326.904L1417.09 315.104ZM1693.14 293.482C1590.08 337.496 1517.79 333.687 1417.09 315.104L1414.91 326.904C1516.86 345.718 1591.8 349.811 1697.86 304.518L1693.14 293.482Z",
    fill: "#6AD67D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1631 265C1567.03 291.599 1521.99 289.245 1460 278.107",
    stroke: "white",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5221_44556"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 104.646,
    height: 115.049,
    fill: "white",
    transform: "translate(221.247 449.521) rotate(-137.576)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5221_44556"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 104.646,
    height: 115.049,
    fill: "white",
    transform: "translate(1477.35) rotate(45)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyUsBg);
export default __webpack_public_path__ + "static/media/why_us_bg.a180849a0ed5da5ace51569ead01f654.svg";
export { ForwardRef as ReactComponent };